/**
 * 人员树 
  POST /ucenter/user/tree
 */
import { useFetch } from "../../../hooks";
export var useApiUCenterUserTree = function useApiUCenterUserTree() {
  var _useFetch = useFetch(),
    post = _useFetch.post;
  var DEFAULT_URL = '/ucenter/user/tree';
  return function () {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_URL;
    var params = arguments.length > 1 ? arguments[1] : undefined;
    return post({
      url: url === '' ? DEFAULT_URL : url,
      data: params
    }).then(function (res) {
      if (res.code === 0 && Array.isArray(res.data)) {
        return res.data;
      }
      return [];
    }).catch(function (error) {
      return error.response.data;
    });
  };
};